import { useRef, useLayoutEffect } from "react";

export function usePortal(): HTMLElement {
  const portal = useRef(document.createElement("div"));

  useLayoutEffect(() => {
    portal.current.style.position = "fixed";
    portal.current.style.zIndex = "200";
    document.body.appendChild(portal.current);
    return () => {
      portal.current.remove();
    };
  }, []);

  return portal.current;
}
